import * as tslib_1 from "tslib";
import "./../styles/main.scss";
import Siema from 'siema';
import Rellax from "rellax";
import $ from "jquery";
import Plyr from "plyr";
import inView from "in-view";
import * as basicLightbox from 'basiclightbox';
require('jquery.scrollto');
var Cookies = require("js-cookie");
var loadGoogleMapsApi = require('load-google-maps-api');
var AsteriaGoogleStyle = [
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 13
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#000000"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#144b53"
            },
            {
                "lightness": 14
            },
            {
                "weight": 1.4
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#18132d"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#0e4051"
            },
            {
                "lightness": 5
            }
        ]
    },
    {
        "featureType": "poi.attraction",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.government",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.medical",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#f6f6f6"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 25
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#0b3d51"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "saturation": "100"
            },
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#000000"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#fff7f7"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.icon",
        "stylers": [
            {
                "saturation": "13"
            },
            {
                "visibility": "on"
            },
            {
                "weight": "1.86"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "color": "#146474"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#021019"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#000000"
            }
        ]
    }
];
$(document).ready(function () {
    var e_1, _a;
    var rellax = null;
    if ($('.rellax').length) {
        window.addEventListener("resize", handleResize);
        handleResize();
    }
    function handleResize() {
        if (window.innerWidth <= 580 && rellax) {
            rellax.destroy();
            rellax = null;
        }
        else if (window.innerWidth > 580 && !rellax) {
            rellax = new Rellax('.rellax', {
                center: true
            });
        }
    }
    if (filter != false) {
        if (filter != "all") {
            $('.real-estates').children('li').hide();
            $('li[data-provider="' + filter + '"]').show();
            Cookies.set('hasprovider', filter, { expires: 365 });
        }
        else {
            Cookies.remove("hasprovider");
        }
    }
    if (Cookies.get('hasprovider') !== void 0) {
        $('.real-estates').children('li').hide();
        $('li[data-provider="' + Cookies.get('hasprovider') + '"]').show();
    }
    $("body").on("click", "a[href^='#']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        var posY = $(node).offset().top - $("#main-header").height();
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    var headerSliderNode = $('header .slider');
    // const interludeSliderNode = $('#interlude .slider');
    if (headerSliderNode.length) {
        var bigSlider_1 = new Siema({
            selector: 'header .slider .siema',
            loop: true,
            onInit: function () {
                headerSliderNode.find('.navigation').children(":nth-child(1)").addClass("active");
            },
            onChange: function () {
                var navigation = headerSliderNode.find(".navigation");
                navigation.find(".active").removeClass("active");
                navigation.children(":nth-child(" + (this.currentSlide + 1) + ")").addClass("active");
            }
        });
        headerSliderNode.find(".navigation").on("click", "span", function (e) {
            bigSlider_1.goTo($(e.currentTarget).index());
        });
        headerSliderNode.on("click", ".control a", function (e) {
            var elm = $(e.currentTarget);
            if (elm.parent().hasClass("left")) {
                bigSlider_1.prev();
            }
            else {
                bigSlider_1.next();
            }
        });
    }
    var siemas = document.querySelectorAll('.properties-wrapper .siema');
    try {
        for (var siemas_1 = tslib_1.__values(siemas), siemas_1_1 = siemas_1.next(); !siemas_1_1.done; siemas_1_1 = siemas_1.next()) {
            var siema = siemas_1_1.value;
            new Siema({
                selector: siema,
                loop: true,
                onInit: function () {
                }
            });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (siemas_1_1 && !siemas_1_1.done && (_a = siemas_1["return"])) _a.call(siemas_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    $('.properties-wrapper').each(function (i, e) {
        var properties = $(e);
        var parent = $(e).children("ul");
        parent.children("li:first").addClass("active");
        parent.children("li").on("click", function (e) {
            parent.children().removeClass("active");
            $(e.currentTarget).addClass("active");
            var index = $(e.currentTarget).index();
            properties.children('div').children('.slider').hide();
            properties.children('div').children('.slider:nth-child(' + (index + 1) + ')').show();
        });
    });
    var inrterludeSlider = new Siema({
        selector: '#interlude .slider .siema',
        loop: true
    });
    var list = new Siema({
        selector: '#properties .list',
        draggable: false,
        duration: 0,
        onInit: function () {
            $('#properties .filters ul').children(":first").addClass("active");
        },
        onChange: function () {
            var navigation = $('#properties .filters ul');
            navigation.find(".active").removeClass("active");
            navigation.children(":nth-child(" + (this.currentSlide + 1) + ")").addClass("active");
        }
    });
    $("#properties").on("click", ".list .control a", function (e) {
        var elm = $(e.currentTarget);
        if (elm.parent().hasClass("left")) {
            list.prev();
        }
        else {
            list.next();
        }
    });
    $('#properties .filters').on("click", "a", function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var parentIndex = $this.parent().index();
        list.goTo(parentIndex);
    });
    loadGoogleMapsApi({
        key: "AIzaSyDQd_Pyw6y8id7gHiUdwgootUXnEgWJCnY"
    }).then(function (googleMaps) {
        var mapNode = document.getElementById('map');
        var styledMap = new googleMaps.StyledMapType(AsteriaGoogleStyle, { name: 'Asteria styled Map' });
        var location = {
            lat: $(mapNode).data("lat"),
            lng: $(mapNode).data("lng")
        };
        var map = new googleMaps.Map(mapNode, {
            center: location,
            zoom: 16
        });
        var marker = new googleMaps.Marker({
            position: location,
            map: map,
            title: 'Hello World!'
        });
        map.mapTypes.set('asteria_map', styledMap);
        map.setMapTypeId('asteria_map');
    })["catch"](function (error) {
        console.error(error);
    });
    var lightboxs = {};
    $('.Button.plan').on("click", function (e) {
        e.preventDefault();
        if (typeof lightboxs[$(e.currentTarget).data("id")] === 'undefined') {
            lightboxs[$(e.currentTarget).data("id")] = basicLightbox.create("\n                <iframe width=\"800\" height=\"500\" style=\"width: 80%; height: 80vh;\" src=\"" + $(e.currentTarget).attr("href") + "\" frameborder=\"0\" allowfullscreen></iframe>\n            ");
        }
        lightboxs[$(e.currentTarget).data("id")].show();
    });
    if ($('#player').length) {
        var player_1 = new Plyr('#player', {});
        // setTimeout(function(){
        //     player.play();
        // }, 1500);
        inView.offset(150);
        inView('main > header')
            .on('enter', function (el) {
            player_1.play();
        })
            .on('exit', function (el) {
            player_1.pause();
        });
    }
});
